<template>
  <b-row>
    <b-col>
      <fieldset class="font-weight-bold text-muted small">
        {{ descricao }}
      </fieldset>
    </b-col>
    <b-col cols="12">
      <hr
        class="mx-0 mt-0 mb-2"
        style="border-top: 1px solid #a3a4a66b !important;"
      >
    </b-col>
    <b-form-group
      label="Descrição"
      class="col-9"
    >
      <validation-provider
        #default="{ errors }"
        rules="required"
        name="Descrição"
      >
        <b-input
          v-model="form.descricao"
          placeholder="Insira uma descrição"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
    <b-form-group
      label="Template"
      class="col-3"
    >
      <validation-provider
        #default="{ errors }"
        rules="required"
        name="template"
      >
        <b-form-select
          v-model="form.template"
          :options="templateOptions"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
    <b-form-group
      label="Tipo de e-mail"
      class="col-4"
    >
      <validation-provider
        #default="{ errors }"
        rules="required"
        name="Tipo-e-mail"
      >
        <b-select
          v-model="form.tipoEmail"
          :options="tipoEmailOptions"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
    <b-col cols="8">
      <b-form-group label="Tipo">
        <validation-provider
          #default="{ errors }"
          rules="required"
          name="Tipo"
        >
          <div>
            <multiselect
              ref="tipoMultiselect"
              v-model="form.tipos"
              :options="tipoOpcoes"
              label="text"
              placeholder=""
              track-by="value"
              class="tipo-multiselect"
              :multiple="true"
              :select-label="''"
              :deselect-label="''"
              :selected-label="''"
            >
              <template
                slot="singleLabel"
                slot-scope="{ option }"
              >
                <strong>{{ option.text }}</strong>
              </template>
            </multiselect>
          </div>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<style src="@core/scss/vue/libs/quill.scss" lang="scss"></style>
<style lang="scss">
.ql-editor {
  height: 800px;
  overflow: auto;

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar {
    width: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #bfbfbf;
  }
}
.tipo-multiselect {
  background: none;
  border-radius: 0.357rem;

  & .multiselect__content {
    display: block !important;
  }

  & .multiselect__element {
    font-size: 0.9rem;
  }

  & .multiselect__strong {
    right: 26px !important;
  }

  & .multiselect__tags {
    padding-right: 0px !important;
    max-height: auto !important;
  }

  & .multiselect__tag {
    white-space: nowrap !important;
    overflow: hidden !important;
    max-width: calc(23em - 25px);
    text-overflow: ellipsis !important;
    background: var(--primary) !important;
    border-radius: 3px !important;
    span {
      font-size: 0.9rem;
    }
  }

  & .multiselect__option {
    & svg {
      display: none;
    }
  }

  & .multiselect__option--selected {
    background: var(--primary) !important;
    color: #ffffff !important;
    font-weight: normal;
    & .company-identification span {
      color: #ffffff !important;
      background-color: transparent;
      border: 1px solid #ffffff !important;
    }
    & svg {
      display: inline;
    }
  }

  & .multiselect__option--highlight {
    background: rgba(var(--primary-rgb), 0.1);
    color: var(--primary);
  }

  & .multiselect__strong {
    color: var(--primary);
    cursor: pointer;
  }

  & .multiselect__tag-icon::after {
    color: #a6eda06e;
    font-size: 1.7rem;
  }

  & .multiselect__tag-icon:hover {
    background: none;
  }
}
</style>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: 'CadastroTemplate',
  components: {
    ValidationProvider,
    Multiselect,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    titulo: {
      type: String,
      required: true,
    },
    descricao: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      required,
      form: {
        templateVinculo: 'contrato',
        tipoTemplate: null,
      },
      templateOptions: [
        { value: 0, text: 'E-mails comercial' },
      ],
      tipoEmailOptions: [
        { value: 0, text: 'Proposta comercial publicada' },
        { value: 1, text: '(Lembrete) Proposta comercial publicada' },
      ],
      tipoOpcoes: [
        { value: 0, text: 'Proposta para serviços eventuais' },
        { value: 1, text: 'Proposta honorários de constituição' },
        { value: 2, text: 'Proposta honorários de transferência' },
      ],
      valueOption: null,
    }
  },
  wacth: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.form = value
      }
    },
  },
  created() {
    this.state = this.$route.path.indexOf('editar') > 0 ? 'editar' : 'novo'
    this.form = this.value
    this.form.template = 0
  },
  methods: {
    mudarOpcoesTipo() {
      this.form.nivel = null
      this.form.tipoTemplate = null
    },
  },
}
</script>
